import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { ScrollDirection } from '../DiscordButton/hooks/useDetectScrollDirection';

type TTerritoryTabStickyWrapperProps = {
  children: ReactNode;
  scrollDirection: ScrollDirection;
  navbarHeight: number;
};

export const TerritoryTabStickyWrapper: FC<TTerritoryTabStickyWrapperProps> = ({
  scrollDirection,
  navbarHeight,
  children,
}) => (
  <div
    className={cx('transition-all top-0 pb-6 sticky z-10 duration-200 bg-white-100', {
      '!pt-2 invisible animate-fade-out -translate-y-full': scrollDirection === ScrollDirection.down,
      'animate-fade-in': scrollDirection === ScrollDirection.up,
    })}
    style={{ top: scrollDirection === ScrollDirection.up ? `${navbarHeight}px` : undefined }}
  >
    <div className="relative">
      <div className="absolute top-0 -z-10 w-full py-5 -my-10 bg-white-100" />
    </div>
    {children}
  </div>
);
